module.exports = __webpack_public_path__ + "img/contentImg5.4105b45.png";